<!-- Loading skeleton -->
<ng-container *ngIf="loading">
  <div [class]="gridClass">
    <div
      *ngFor="let _ of skeletonItems"
      class="gw-relative gw-bg-background-elevation-2 gw-rounded-2xl gw-p-6 gw-border-base gw-animate-pulse"
    >
      <div class="gw-flex gw-gap-4">
        <div
          class="gw-flex-shrink-0 gw-w-12 gw-h-12 gw-rounded-lg gw-bg-background-elevation-1"
        ></div>
        <div class="gw-flex-1 gw-space-y-2">
          <div
            class="gw-h-4 gw-rounded gw-bg-background-elevation-1"
            style="width: 75%"
          ></div>
          <div
            class="gw-h-8 gw-rounded gw-bg-background-elevation-1"
            style="width: 50%"
          ></div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Metric cards -->
<ng-container *ngIf="!loading && metrics?.length">
  <div [class]="gridClass">
    <ng-container *ngFor="let metric of metrics">
      <!-- Card with link (routerLink) -->
      <a
        *ngIf="metric.link && metric.routerLink"
        [routerLink]="metric.link"
        [class]="getCardClass(metric)"
        class="gw-block gw-no-underline gw-text-inherit"
        (click)="onCardClick(metric, $event)"
      >
        <div
          class="gw-flex gw-flex-col sm:gw-flex-row sm:gw-items-start gw-gap-4"
        >
          <figure
            *ngIf="metric.icon"
            class="gw-flex-shrink-0 gw-m-0 gw-p-2 gw-rounded-lg gw-bg-background-elevation-1"
            [class]="getColorClass(metric.color)"
          >
            <gatewee-icon
              [icon]="metric.icon"
              size="18px"
              class="gw-block"
            ></gatewee-icon>
          </figure>
          <div class="gw-min-w-0 gw-flex-1">
            <h3
              class="gw-text-text-secondary gw-text-sm gw-font-medium gw-mb-1"
            >
              {{ metric.title }}
            </h3>
            <p
              class="gw-text-3xl gw-font-bold gw-mb-0"
              [ngClass]="getValueToneClass(metric)"
            >
              {{ metric.value }}
            </p>
            <p
              *ngIf="metric.description"
              class="gw-text-xs gw-font-medium gw-mt-1 gw-mb-0"
              [ngClass]="getDescriptionToneClass(metric)"
            >
              {{ metric.description }}
            </p>
            <span
              *ngIf="metric.badge"
              class="gw-inline-block gw-mt-2 gw-text-xs gw-font-medium gw-text-text-secondary"
            >
              {{ metric.badge }}
            </span>
          </div>
        </div>
      </a>

      <!-- Card with href (external link) -->
      <a
        *ngIf="metric.link && !metric.routerLink"
        [href]="metric.link"
        [class]="getCardClass(metric)"
        class="gw-block gw-no-underline gw-text-inherit"
        rel="noreferrer"
        target="_blank"
        (click)="onCardClick(metric, $event)"
      >
        <div
          class="gw-flex gw-flex-col sm:gw-flex-row sm:gw-items-start gw-gap-4"
        >
          <figure
            *ngIf="metric.icon"
            class="gw-flex-shrink-0 gw-m-0 gw-p-2 gw-rounded-lg gw-bg-background-elevation-1"
            [class]="getColorClass(metric.color)"
          >
            <gatewee-icon
              [icon]="metric.icon"
              size="18px"
              class="gw-block"
            ></gatewee-icon>
          </figure>
          <div class="gw-min-w-0 gw-flex-1">
            <h3
              class="gw-text-text-secondary gw-text-sm gw-font-medium gw-mb-1"
            >
              {{ metric.title }}
            </h3>
            <p
              class="gw-text-3xl gw-font-bold gw-mb-0"
              [ngClass]="getValueToneClass(metric)"
            >
              {{ metric.value }}
            </p>
            <p
              *ngIf="metric.description"
              class="gw-text-xs gw-font-medium gw-mt-1 gw-mb-0"
              [ngClass]="getDescriptionToneClass(metric)"
            >
              {{ metric.description }}
            </p>
            <span
              *ngIf="metric.badge"
              class="gw-inline-block gw-mt-2 gw-text-xs gw-font-medium gw-text-text-secondary"
            >
              {{ metric.badge }}
            </span>
          </div>
        </div>
      </a>

      <!-- Card without link (clickable via output) -->
      <div
        *ngIf="!metric.link"
        [class]="getCardClass(metric)"
        (click)="onCardClick(metric, $event)"
      >
        <div
          class="gw-flex gw-flex-col sm:gw-flex-row sm:gw-items-start gw-gap-4"
        >
          <figure
            *ngIf="metric.icon"
            class="gw-flex-shrink-0 gw-m-0 gw-p-2 gw-rounded-lg gw-bg-background-elevation-1"
            [class]="getColorClass(metric.color)"
          >
            <gatewee-icon
              [icon]="metric.icon"
              size="18px"
              class="gw-block"
            ></gatewee-icon>
          </figure>
          <div class="gw-min-w-0 gw-flex-1">
            <h3
              class="gw-text-text-secondary gw-text-sm gw-font-medium gw-mb-1"
            >
              {{ metric.title }}
            </h3>
            <p
              class="gw-text-3xl gw-font-bold gw-mb-0"
              [ngClass]="getValueToneClass(metric)"
            >
              {{ metric.value }}
            </p>
            <p
              *ngIf="metric.description"
              class="gw-text-xs gw-font-medium gw-mt-1 gw-mb-0"
              [ngClass]="getDescriptionToneClass(metric)"
            >
              {{ metric.description }}
            </p>
            <span
              *ngIf="metric.badge"
              class="gw-inline-block gw-mt-2 gw-text-xs gw-font-medium gw-text-text-secondary"
            >
              {{ metric.badge }}
            </span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
